// extracted by mini-css-extract-plugin
export var carrierTab = "_3u-0";
export var carrierTabActive = "_3u-1 _3u-0";
export var carrierTabInactive = "_3u-2 _3u-0";
export var carrierTabLabel = "_3u-3";
export var carrierTabLabelActive = "_3u-4 _3u-3";
export var carrierTabLabelInactive = "_3u-5 _3u-3";
export var carrierTabPercentage = "_3u-6";
export var carrierTabPercentageActive = "_3u-7 _3u-6";
export var carrierTabPercentageInactive = "_3u-8 _3u-6";
export var carrierTabWinnable = "_3u-9";
export var carrierTabWinnableActive = "_3u-a _3u-9";
export var carrierTabWinnableInactive = "_3u-b _3u-9";
export var comparisonContainer = "_3u-d";
export var missingRateButton = "_3u-n";
export var missingRateButtonActive = "_3u-o _3u-n";
export var missingRateButtonInactive = "_3u-p _3u-n";
export var missingRateButtonLabel = "_3u-q";
export var missingRateButtonLabelActive = "_3u-r _3u-q";
export var missingRateButtonLabelInactive = "_3u-s _3u-q";
export var sidebar = "_3u-c";
export var strategyButton = "_3u-e";
export var strategyButtonActive = "_3u-f _3u-e";
export var strategyButtonDescription = "_3u-k";
export var strategyButtonDescriptionActive = "_3u-l _3u-k";
export var strategyButtonDescriptionInactive = "_3u-m _3u-k";
export var strategyButtonInactive = "_3u-g _3u-e";
export var strategyButtonLabel = "_3u-h";
export var strategyButtonLabelActive = "_3u-i _3u-h";
export var strategyButtonLabelInactive = "_3u-j _3u-h";
export var unitToggleButton = "_3u-t";
export var unitToggleButtonActive = "_3u-u _3u-t";
export var unitToggleButtonInactive = "_3u-v _3u-t";
export var unitToggleButtonLabel = "_3u-w";
export var unitToggleButtonLabelActive = "_3u-x _3u-w";
export var unitToggleButtonLabelInactive = "_3u-y _3u-w";